import { render, staticRenderFns } from "./invastogationSpaceBarChart.vue?vue&type=template&id=5f7fc189&scoped=true"
import script from "./invastogationSpaceBarChart.vue?vue&type=script&lang=js"
export * from "./invastogationSpaceBarChart.vue?vue&type=script&lang=js"
import style0 from "./invastogationSpaceBarChart.vue?vue&type=style&index=0&id=5f7fc189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7fc189",
  null
  
)

export default component.exports